import { combineReducers } from 'redux';

import main from './main';

export default combineReducers({ main });
